var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrev = function SvgPrev(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.53 2.196a.75.75 0 0 0-1.06-1.06l-9.333 9.333a.747.747 0 0 0-.002 1.06h.002m0 .001 9.333 9.333a.75.75 0 0 0 1.06-1.06l-8.052-8.054h16.856a.75.75 0 1 0 0-1.5H3.478l8.053-8.053",
    fill: "#A9B0B4"
  })));
};
export default SvgPrev;